import { SettingsNavigation, type SettingsNavigationItem } from '../SettingsNavigation'

const ITEMS: SettingsNavigationItem[] = [
  {
    id: 'settings-tab-profile-data',
    label: 'Profildaten',
    to: '/settings/profile',
  },
  {
    id: 'settings-tab-profile-account',
    label: 'Kontodaten',
    to: '/settings/profile/account',
  },
]

export function ProfileSettingsNav() {
  return <SettingsNavigation items={ITEMS} />
}
